import { render, staticRenderFns } from "./DocumentLink.vue?vue&type=template&id=4f3b5fde"
import script from "./DocumentLink.vue?vue&type=script&lang=ts"
export * from "./DocumentLink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports